import { prop } from 'ramda'

export const getPayment = prop('payment')
